import { TRoomDetail } from '@/entities/room'
import { formatCurrency } from '@/shared/lib'

type Props = Pick<TRoomDetail, 'usingFee' | 'mgmtFee' | 'minimumContractWeeks'>

export const RoomInformation = ({
  usingFee,
  mgmtFee,
  minimumContractWeeks,
}: Props) => {
  return (
    <div className="mb-7.5 space-y-2 px-6">
      <dl className="typo-body1 flex gap-1 font-normal">
        <dt className="text-gray-500">최소 계약 기간</dt>
        <dd className="text-gray-900">{minimumContractWeeks}주</dd>
      </dl>
      <div className="typo-headline3 flex items-center gap-2">
        <p className="flex items-center gap-0.5">
          <span className="typo-title2 font-bold text-black">
            {formatCurrency(usingFee + mgmtFee)}
          </span>
          <span className="font-normal text-black">원</span>
        </p>
        <span className="font-light text-gray-200">/</span>
        <span className="font-semibold text-purple-500">1주</span>
      </div>
      <dl className="flex gap-3">
        <div className="typo-body1 flex gap-1 font-normal">
          <dt className="text-gray-500">임대료</dt>
          <dd className="text-gray-900">{formatCurrency(usingFee)}원</dd>
        </div>
        <div className="typo-body1 flex gap-1 font-normal">
          <dt className="text-gray-500">관리비</dt>
          <dd className="text-gray-900">{formatCurrency(mgmtFee)}원</dd>
        </div>
      </dl>
    </div>
  )
}
